import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSettingsFormStore } from '../store';
import { THEME } from '../types';
import type { Theme } from '../types';

const THEMES = [
  { value: THEME.SYSTEM, labelKey: 'settings.themeSystem' },
  { value: THEME.LIGHT, labelKey: 'settings.themeLight' },
  { value: THEME.DARK, labelKey: 'settings.themeDark' },
] as const;

/** Apply data-theme attribute to <html> for CSS var overrides. */
function applyTheme(theme: Theme): void {
  const html = document.documentElement;
  if (theme === THEME.SYSTEM) {
    // Remove override — let Telegram theme vars take effect
    html.removeAttribute('data-theme');
  } else {
    html.setAttribute('data-theme', theme);
  }
}

export function ThemeSelector() {
  const { t } = useTranslation();
  const theme = useSettingsFormStore((s) => s.theme);
  const setTheme = useSettingsFormStore((s) => s.setTheme);

  // Apply theme whenever it changes
  useEffect(() => {
    applyTheme(theme as Theme);
  }, [theme]);

  return (
    <div className="space-y-2">
      <h3
        className="text-sm font-medium text-tg-hint"
      >
        {t('settings.theme')}
      </h3>
      <div className="flex gap-2">
        {THEMES.map((item) => (
          <button
            key={item.value}
            type="button"
            onClick={() => setTheme(item.value)}
            className="flex-1 rounded-lg px-4 py-2.5 text-sm font-medium transition-colors"
            style={{
              backgroundColor:
                theme === item.value
                  ? 'var(--tg-theme-button-color)'
                  : 'var(--tg-theme-secondary-bg-color)',
              color:
                theme === item.value
                  ? 'var(--tg-theme-button-text-color)'
                  : 'var(--tg-theme-text-color)',
            }}
          >
            {t(item.labelKey)}
          </button>
        ))}
      </div>
    </div>
  );
}
